<div class="exchange-rates-page">
  <header class="project-header">
    <p class="eyebrow">Portfolio :: Exchange Rates</p>
    <div class="hero-layout">
      <div>
        <h1>Exchange Rates</h1>
        <div class="meta-badges">
          <span>Android</span>
          <span>Kotlin</span>
          <span>Finance</span>
          <span>REST API</span>
        </div>
      </div>
    </div>
  </header>

  <div class="content-grid">
    <section class="project-copy">
      <p>
        Exchange Rates is a Kotlin-based Android app designed to help users browse exchange-rate
        data in a clear, readable interface. It pulls daily currency information from a REST API and
        presents the newest results in a clean, swipe-friendly experience.
      </p>

      <ul class="feature-list">
        <li>Fetch exchange-rate data for sequential days and sort it by newest date.</li>
        <li>Use gesture-based navigation to expand and collapse the extended toolbar.</li>
        <li>Switch between Polish and English in the app interface.</li>
        <li>Follow the MVP pattern to keep the app structure clean and maintainable.</li>
      </ul>

      <a class="project-link" target="_blank" rel="noopener"
         href="https://github.com/jawegielewski/Exchange-Rates">
        View on GitHub
      </a>
    </section>

    <aside class="project-visual screenshot-gallery">
      <img class="phone-shot" src="../../../../assets/images/exchange_rates_screenshot1.png"
           alt="Exchange Rates screenshot">
    </aside>
  </div>
</div>
